<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="icons" clip-path="url(#clip0_4001_1332)">
      <path
        id="layer2"
        d="M16.6291 16.6291C20.2903 12.968 20.2903 7.03204 16.6291 3.37087C12.968 -0.290291 7.03204 -0.290291 3.37087 3.37087C-0.290294 7.03204 -0.290294 12.968 3.37087 16.6291C7.03204 20.2903 12.968 20.2903 16.6291 16.6291Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        id="Line 9"
        d="M6.35355 6.64648L13.3535 13.6465"
        stroke="currentColor"
        stroke-linecap="round"
      />

      <path
        id="Line 10"
        d="M6.64645 13.6465L13.6465 6.64648"
        stroke="currentColor"
        stroke-linecap="round"
      />
    </g>

    <defs>
      <clipPath id="clip0_4001_1332">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
</template>
